import { useState } from "react"

import { useQuery } from "@tanstack/react-query"

import { getBalanceRegions } from "@/features/balance-map/api/getBalanceRegions"
import BalanceMap from "@/features/balance-map/components/BalanceMap"
import ForHireHeader from "@/features/balance-map/components/ForHireHeader"
import RegionBalanceTable from "@/features/balance-map/components/RegionBalanceTable"

export default function ForHireBalanceMap() {
  const { data } = useQuery({
    queryKey: ["balanceRegions"],
    queryFn: getBalanceRegions,
    refetchInterval: 15000,
  })

  const [hoveredRegionId, setHoveredRegionId] = useState<number | null>(null)

  return (
    <div>
      <ForHireHeader />
      <div className="w-full flex flex-col xl:flex-row gap-4 xl:h-[600px]">
        <div className="hidden xl:block">
          <BalanceMap regions={data || []} hoveredRegionId={hoveredRegionId} />
        </div>
        <div className="rounded-md shadow-sm border grow-1 min-h-0">
          <RegionBalanceTable
            regions={data || []}
            hoveredRegionId={hoveredRegionId}
            onRegionHoverChange={setHoveredRegionId}
          />
        </div>
      </div>
    </div>
  )
}
